<template>
      <section>
            <div class="container">
                  <div class="row">
                        <div class="col-sm-12">
                              
                              <div class="wrapper-page">
                                    
                                    <div class="account-pages">
                                          <div class="account-box">
                                                <div class="account-logo-box">
                                                      <h2 class="text-uppercase text-center">
                                                            <a href="#/" class="text-success">
                                                                  <span>
                                                                        <!--<img src="images/logo-light-icon.png" alt="" height="20">-->
                                                                        特许私人财富管理师
                                                                  </span>
                                                            </a>
                                                      </h2>
                                                </div>
                                                <div class="account-content">
                                                      <div class="text-center m-b-20">
                                                            <div class="m-b-20">
                                                                  <div class="checkmark">
                                                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                                             viewBox="0 0 161.2 161.2" enable-background="new 0 0 161.2 161.2" xml:space="preserve">
                                                    <path class="path" fill="none" stroke="#32c861" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4
                                                        c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5
                                                        c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"/>
                                                                              <circle class="path" fill="none" stroke="#32c861" stroke-width="4" stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1"/>
                                                                              <polyline class="path" fill="none" stroke="#32c861" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="113,52.8
                                                        74.1,108.4 48.2,86.4 "/>
                                                                              
                                                                              <circle class="spin" fill="none" stroke="#32c861" stroke-width="4" stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6" r="73.9"/>

                                                </svg>
                                                                  
                                                                  </div>
                                                            </div>
                                                            
                                                            
                                                            <p class="text-muted font-14 m-t-10"> 您已经安全退出系统，再见。返回<a href="#/" class="text-primary m-r-5"><b>登录</b></a></p>
                                                      </div>
                                                
                                                </div>
                                          </div>
                                    </div>
                                    <!-- end card-box-->
                              
                              
                              </div>
                              <!-- end wrapper -->
                        
                        </div>
                  </div>
            </div>
      </section>

</template>

<script>
      export default {
            name: 'left',
            mounted(){
                  this.loginout();
            },
            methods:{
                  loginout:function(){
                        localStorage.removeItem('membertoken');
                        //this.goto('/baoming/#/downticket');
                        console.log('login out!');
                  }
            },

      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      section {
            background-color: #5d6dc3;
            background: linear-gradient(to top, #5d6dc3, #3c86d8);
            padding-bottom: 0;
            min-height: 100px;
      }
  
     
</style>



// WEBPACK FOOTER //
// src/components/loginout.vue